import Vue from 'vue'

// import parse from 'date-fns/parse'
// import format from 'date-fns/format'

import {format, parseISO} from 'date-fns'


const localeOptions = new Intl.DateTimeFormat().resolvedOptions();

Vue.filter('fmtdate', (value, fmt='MM/dd/yyyy h:mm a') => {
    if (value === null || value === undefined) {
        return 'Never'
    }

    let date = parseISO(value);
    // let parts = Intl.DateTimeFormat(localeOptions.locale, {timeZoneName: 'short'}).formatToParts(date);

    return `${format(date, fmt)}`;
})

Vue.filter('currency', (value) => {
    if (value === null || value === undefined) {
        return ''
    }

    let val = value.replace(/[^\d\.]+/g, '')

    if (!val) {
        return ''
    }

    let fmt = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});

    return fmt.format(val);
})

Vue.filter('phone', (value) => {
    if (!value) return '';

    let val = value.replace(/[^\d]+/g, '')
    if (!val) return '';

    return val.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
})


window.b64encode = (str) => {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16))
    }))
}

